<!--

 props.colsのスキーマデータをもとにループして処理

-->
<template>
  <div>
    <div
      v-if="!loading && localTableData.length === 0"
      class="flex align-center justify-center text-gray-600 text-14"
      :style="{ height: `${tableHeight}px`, backgroundColor: '#fafafa', borderTop: '35px solid #f1f1fb'}"
    >
      No Data
    </div>
  <el-table
      v-else
    ref="tableRef"
    :data="localTableData"
    style="width: 100%"
    :size="localSize"
    :stripe="localStripe"
    :height="tableHeight"
    class="custom-scroll"
    :row-class-name="rowClassName"
    :border="border"
    :resizable="true"
    v-loading="loading"
    @header-dragend="handleColumnWidthChange"
    @row-click="handleClickRow"
    @row-contextmenu="onRowContextmenu"
    @sort-change="handleSortChange"
  >
    <el-table-column
      v-for="(col, index) in localCols"
        :key="( col.prop || col.key ) + index"
      :prop="col.prop"
      :type="col.dataType"
      :label="getLabel(col.label)"
      :width="col.width"
      :sortable="col.sortable ? 'custom' : false"
      :align="col.align"
      :index="index"
      :show-overflow-tooltip="col.showOverflowTooltip"
      :class-name="getSortClass(col.prop)"
    >
        <template slot="header" v-if="col.prop !== 'tradingProgressStatusCd'">
          <span class="th-text" :title="getLabel(col.label)">{{ getLabel(col.label) }}</span>
        </template>

      <!-- 親から来た slot があるか確認 -->
      <template v-if="$scopedSlots[col.prop]" v-slot="scope">
        <slot :name="col.prop" v-bind="scope" />
      </template>


        <template v-else v-slot="scope">
        <template v-if="col.prop === 'name'">
          <span class="text-bold">{{ scope.row.name }}</span>
        </template>

        <template v-else-if="col.prop === 'tradingProgressStatusCd'">
          <tw-trading-status-icon
            v-if="scope.row[col.prop] || scope.row[col.prop] === 0"
            :statusCode="scope.row[col.prop]"
          />
        </template>

        <!-- プロセスカテゴリーのアイコン -->
        <template v-else-if="col.prop === 'entityTypeCd'">
          <TwAlertIcon
            v-if="!editMode"
            type="line"
            :limit="scope.row['calculatedDueDate'] || ''"
            :processProgressStatus="scope.row['processProgressStatusCd']"
          />
          <TwEntityIcon :entityName="getCategoryName(scope.row.entityTypeCd)" />
        </template>

        <!-- プロセスステータス -->
        <template v-else-if="col.prop === 'processProgressStatusCd'">
          <tw-status-bar
            :statusCode="scope.row[col.prop]"
            :approval="
              scope.row.processId
                ? getProgressApproval(scope.row.processId)
                : true
            "
          />
        </template>

        <template v-else-if="col.dataType === 'ForcedClose'">
          <div v-if="isForcedClose(scope.row)">
            <tw-status-label v-if="$store.getters.getLanguageKey === 'local'" statusName="FORCED_CLOSE_JAPANESE" style="font-size: 12px" />
            <tw-status-label v-else statusName="FORCED_CLOSE_ENGLISH" style="font-size: 10px" />
          </div>
        </template>

        <!-- プロセス名称とプロセス削除ボタン -->
        <template v-else-if="col.prop === 'processName'">
          <div class="flex align-center gap-8">
            <div v-if="editMode && canDeleteProcess(scope.row) && !isFwd" class="ml-1">
              <el-button
                type="text"
                icon="el-icon-close"
                size="small"
                circle
                @click="handleClickDeleteProcess(scope.row)"
              />
            </div>
            <div v-if="isEventCancelProcess(scope.row)" class="ellipsis-text">
              <tw-status-label statusName="DELETE" />
            </div>
            <div>{{ getProcessExShortName(scope.row.processId) }}</div>
          </div>
        </template>

        <!-- プロセス更新者 -->
        <template v-else-if="col.prop === 'processUpdateUserName'">
          <div class="flex align-center">
            <div class="mr-2">
              <img
                :src="getUserIcon(scope.row, 'processUpdate')"
                alt="avatar"
                style="width:24px;border-radius:50%;"
              />
            </div>
            <div>{{ scope.row['processUpdateUserName'] }}</div>
          </div>
        </template>

        <!-- 取引フローID -->
        <template v-else-if="col.prop === 'tradingFlowId'">
          <div>
            {{ `${scope.row['tradingId']}/${scope.row['tradingFlowId']}` }}
          </div>
        </template>

          <!-- 取引名 -->
        <template v-else-if="col.prop === 'tradingManageName'">
          <div class="flex flex-align-center">
            <div
              v-if="getFlowLabel(scope.row)"
              class="mr-2"
              :class="{
                'flow-m': getFlowLabel(scope.row) === 'M',
                'flow-s ml-3': getFlowLabel(scope.row) === 'S',
              }"
            >
              {{ getFlowLabel(scope.row) }}
            </div>
            <div>{{ scope.row['tradingManageName'] }}</div>
          </div>
        </template>

          <!-- オーナー -->
          <template v-else-if="col.prop === 'owner'">
            <div class="ellipsis-text">
              {{ `${scope.row['ownerCompanyShortName']}` }}
            </div>
          </template>

          <!-- 取引フローID -->
          <template v-else-if="col.prop === 'tradingChannelInfo.tradingChannelNo'">
            <div>
              {{ `${scope.row['tradingChannelInfo']['tradingChannelNo']}` }}
            </div>
          </template>

        <!-- dataType: Datetime -->
        <template v-else-if="col.dataType === 'DateTime'">
          <div class="text-center">
            {{
              scope.row[col.prop]
                ? dayjs(scope.row[col.prop]).format('YYYY-MM-DD HH:mm')
                : '-'
            }}
          </div>
        </template>

        <!-- dataType: SystemDate -->
        <template v-else-if="col.dataType === 'SystemDate'">
          <div class="text-center">
            {{
              scope.row[col.prop]
                ? dayjs(scope.row[col.prop]).format('YYYY-MM-DD HH:mm')
                : '-'
            }}
          </div>
        </template>

        <!-- dataType: Date -->
        <template v-else-if="col.dataType === 'Date'">
          <div class="text-center">
            {{
              scope.row[col.prop]
                ? dayjs(scope.row[col.prop]).format('YYYY-MM-DD')
                : '-'
            }}
          </div>
        </template>

        <div v-else>
          <!-- 編集可能な項目 -->
          <div v-if="localEditMode && col.editable">
            <!-- 編集可能な項目/dataTypeがinput or selectの場合 -->
            <el-form-item
              v-if="col.dataType !== 'SelectCustomerSeparatedInfo'"
              :prop="col.prop"
              :rules="col.rules"
              :class="{ 'no-margin': !col.rules }"
            >
              <component
                :is="TwTableCell"
                :value="scope.row[col.prop]"
                :edit-mode="true"
                :type="col.type || 'input'"
                :options="col.options || []"
                :rules="col.rules || []"
                :maxLength="col.maxLength"
                :prop="col.prop"
                @input="
                  val => emitUpdate(scope.$index, col.prop, val, scope.row)
                "
              />
            </el-form-item>

            <!-- 編集可能な項目/dataTypeがinput or select以外 -->
            <!-- セクション入力 -->
            <div
              v-else
              class="py-1 px-2"
              :class="{
                editSelectCustomerInfo: editMode && scope.row.editableFlg === 1,
                'cursor-pointer': scope.row.editableFlg === 1,
                  invalid: !scope.row[col.prop].companyShortName && !visibleFlg(scope.row),
              }"
              style="min-height:46px"
              @click="
                handleClickEditSelectCustomerInfo(
                  col.prop,
                  scope.row,
                  scope.$index,
                  scope.row.editableFlg,
                )
              "
            >
              <template v-if="col.prop === 'from' || col.prop === 'to'">
                  <div v-if="visibleFlg(scope.row)" class="text-gray-800">
                    <span
                      style="background-color:#e8e8ed;border-radius:4px;padding:2px 10px;"
                    >
                      {{ maskStr }}
                    </span>
                  </div>
                  <div v-else>
                <el-tooltip
                  effect="dark"
                  :open-delay="2000"
                  :content="scope.row[col.prop].companyName"
                  placement="top-start"
                >
                  <div
                    v-if="scope.row[col.prop].companyShortName"
                    class="ellipsis-text block"
                  >
                    {{ scope.row[col.prop].companyShortName }}
                  </div>
                  <div
                    v-else
                    class="flex justify-center align-center"
                    style="min-height:46px;color:red;"
                  >
                    {{ col.prop }}は入力必須
                  </div>
                </el-tooltip>
                <el-tooltip
                  effect="dark"
                  :open-delay="2000"
                  :content="scope.row[col.prop].sectionName"
                  placement="top-start"
                >
                  <div class="ellipsis-text block">
                    {{ scope.row[col.prop].sectionShortName }}
                  </div>
                </el-tooltip>
                    </div>
              </template>
            </div>
          </div>
          <template v-else-if="col.prop === 'from' || col.prop === 'to'">
              <div v-if="visibleFlg(scope.row)" class="text-gray-800">
              <span
                style="background-color:#e8e8ed;border-radius:4px;padding:2px 10px;"
              >
                {{ maskStr }}
              </span>
            </div>
            <div v-else>
              <el-tooltip
                effect="dark"
                :open-delay="2000"
                :content="scope.row[col.prop].companyName"
                placement="top-start"
              >
                <div class="ellipsis-text block">
                  {{ scope.row[col.prop].companyShortName }}
                </div>
              </el-tooltip>
              <el-tooltip
                effect="dark"
                :open-delay="2000"
                :content="scope.row[col.prop].sectionName"
                placement="top-start"
              >
                <div class="ellipsis-text block">
                  {{ scope.row[col.prop].sectionShortName }}
                </div>
              </el-tooltip>
            </div>
          </template>

          <el-tooltip
            v-else-if="col.prop === 'processUserMemo'"
            effect="dark"
              :content="String(formatter(scope.row, scope.column, scope.row[col.prop]))"
            placement="top-start"
            :open-delay="2000"
            :hide-after="0"
          >
            <div class="process-user-memo">
              {{ scope.row[col.prop] }}
            </div>
          </el-tooltip>

          <template v-else-if="col.dataType === 'hazardous'">
            <div class="text-center">
              <span v-if="isHazardous(scope.row)">
                <img src="@/assets/images/icons/icon_check.svg" style="width:16px">
              </span>
            </div>
          </template>

          <!-- 値が無い項目は「-」を表示 -->
          <template v-else-if="scope.row[col.prop] === '' || scope.row[col.prop] === false || scope.row[col.prop] == null">
            <span class="text-center text-gray-600 px-2">-</span>
          </template>

          <el-tooltip
            v-else
            effect="dark"
              :content="String(formatter(scope.row, scope.column, scope.row[col.prop]))"
            placement="top-start"
            :open-delay="2000"
            :hide-after="0"
          >
            <div class="ellipsis-text">
              {{ formatter(scope.row, scope.column, scope.row[col.prop]) }}
            </div>
          </el-tooltip>
        </div>
      </template>
    </el-table-column>
  </el-table>
  </div>
</template>

<script>
// TODO: 取引ステータスのカスタム表示
//        0, 1, 2しかなさそう tradingProgressStatusCd 設計書確認
// TODO: 各種データてすと本データてすと
// TODO: ページネーション
import _ from 'lodash';
import {
  defineComponent,
  toRefs,
  ref,
  computed,
  onBeforeMount,
  onMounted,
  nextTick,
} from '@vue/composition-api';
import {
  DELETE_ABLE_FLG,
  DETAIL_VIEWABLE_FLG,
  VISIBLE_FLG,
  TRADE_TYPE_VARIABLES,
  TRADE_TYPE_DISPLAY_VARIABLES,
  PAYMENT_TERMS_VARIABLES,
  DELIVERY_TERMS_VARIABLES,
  SUBORDINATE_FLOW_FLG,
  PROCESS_CANCEL_FLG,
  TRANSPORTATION_VARIABLES,
  TYPE_OF_SERVICE_FCL_LCL_VARIABLES,
  HAZARDOUS_FLAG,
  FLOW_HIDDEN_FLAG,
} from 'lib-tw-common';
import dayjs from 'dayjs';

import { processNames, entityNames } from '@/dictionaries/map.js';
import { getProcessNumber } from '@/utils/entity';
import {
  formatQuantity,
  formatCurrency,
  formatNumberString,
  formatUtcDate,
} from '@/utils/searchUtil.js';

import TwTableCell from '@/components/vue3/TwTableCell';
import TwStatusIcon from '@/components/atoms/TwStatusIcon';
import TwStatusLabel from '@/components/atoms/TwStatusLabel';
import TwTradingStatusIcon from '@/components/atoms/TwTradingStatusIcon';
import TwAlertIcon from '@/components/atoms/TwAlertIcon';
import TwEntityIcon from '@/components/atoms/TwEntityIcon';
import TwStatusBar from '@/components/atoms/TwStatusBar';

const EMITS = {
  UPDATE_CELL: 'update-cell',
  UPDATE_TABLE_DATA: 'update:tableData',
  SORT_CHANGE: 'sort-changed',
  COLUMN_WIDTH_CHANGE: 'column-width-changed',
  CLICK_ROW: 'click-row',
  CLICK_SELECT_CUSTOMER: 'click-select-customer',
  CLICK_DELETE_PROCESS: 'click-delete-process',
};

export default defineComponent({
  name: 'TwTable',
  components: {
    TwStatusIcon,
    TwAlertIcon,
    TwEntityIcon,
    TwStatusBar,
    TwStatusLabel,
    TwTableCell,
    TwTradingStatusIcon,
  },
  props: {
    tableData: {
      type: Array,
      required: true,
    },
    cols: {
      type: Array,
      required: true,
    },
    size: {
      type: String,
      default: 'small',
    },
    stripe: {
      type: Boolean,
      default: true,
    },
    offsetY: {
      type: Number,
      default: 200,
    },
    border: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    autoHeight: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit, root }) {
    const maskStr = '*Undisclosed*'; // 伏字文字列

    const { tableData, cols, size, stripe, offsetY, editMode } = toRefs(props);
    const tableRef = ref(null);
    const tableHeight = ref('100%');

    const localEditMode = ref(editMode);
    const isDeletableFlow = ref(true);
    const activeSortState = ref({ prop: null, order: null });

    const isForcedClose = computed(() => {
      return row => {
        return row.forcedClose === FLOW_HIDDEN_FLAG.HIDDEN;
      };
    });

    const canDeleteProcess = computed(() => {
      return row => {
        // TODO: isDeletableFlowの確認
        if (isDeletableFlow) {
          return row.deletableFlg === DELETE_ABLE_FLG.OK;
        } else {
          // 削除不可のフロー（サブフロー等）ではプロセス数を0にはさせない
          return (
            row.deletableFlg === DELETE_ABLE_FLG.OK && tableData.length > 1
          );
        }
      };
    });

    const visibleFlg = computed(() => {
      return row => {
        return row.visibleFlg === VISIBLE_FLG.OFF;
      };
    });

    const isEventCancelProcess = process => {
      return process.eventCancel === PROCESS_CANCEL_FLG.ON;
    };

    const isHazardous = process => {
      return process.hazardousFlag === HAZARDOUS_FLAG.APPLICABLE;
    };

    const getCategoryName = entityTypeCd => {
      return _.get(_.find(entityNames, { code: entityTypeCd }), 'entityId');
    };

    const getUserIcon = computed(() => {
      return (row, key) => {
        return (
          _.get(row, `${key}UseIcon`) ||
          _.get(row, `${key}UserIcon`) ||
          _.get(row, `userIcon${_.capitalize(key)}`) ||
          '/images/avatar.png'
        );
      };
    });

    // 取引管理のフローのメインかサブを返却します
    const getFlowLabel = row => {
      if (!row.subordinateInfo) {
        return '';
      }
      if (row.subordinateInfo.subFlg === SUBORDINATE_FLOW_FLG.ON) {
        return 'S';
      }
      if (row.subordinateInfo.parentFlg === SUBORDINATE_FLOW_FLG.ON) {
        return 'M';
      }
      return '';
    };

    const getSortClass = prop => {
      if (activeSortState.value.prop === prop) {
        return activeSortState.value.order === 'ascending' ? 'active-sort-asc' : 'active-sort-desc'
      }
      else {
        return ''
      }
      }

    const formatter = (row, column, value) => {
      if (column.type === 'TradeTypeCdDisplay') {
        return _.get(
          _.find(TRADE_TYPE_VARIABLES, { code: row[column.property] }),
          'label',
        );
      }

      if (column.type === 'TradeTypeCdDisplay') {
        return _.get(
          _.find(TRADE_TYPE_DISPLAY_VARIABLES, { code: row[column.property] }),
          'label',
        );
      }

      if (column.type === 'PaymentTermsCd') {
        const code = row.paymentTermsCd || row[column.property];
        return _.get(_.find(PAYMENT_TERMS_VARIABLES, { code: code }), 'label');
      }

      if (column.type === 'DeliveryTermsCd') {
        const code = row.deliveryTermsCd || row[column.property];
        return _.get(_.find(DELIVERY_TERMS_VARIABLES, { code: code }), 'label');
      }

      if (column.type === 'Transportation') {
        const code = row.modeOfTransportation != null ? row.modeOfTransportation : row[column.property];
        return _.get(_.find(TRANSPORTATION_VARIABLES, { code: code }), 'label');
      }

      if (column.type === 'TypeOfServiceFclLcl') {
        const code = row.typeOfServiceFrom || row[column.property];
        return _.get(_.find(TYPE_OF_SERVICE_FCL_LCL_VARIABLES, { code: code }), 'label');
      }

      if (column.type === 'Currency') {
        const target = _.get(
          _.find(props.cols, { key: column.property }),
          'target',
        );

        if (
          !target ||
          !row[target] ||
          !root.$store.state.systemProperties.SYS_MST_CURRENCY
        ) {
          return formatCurrency(value);
        }
        const rule = _.find(root.$store.getters.getSysMstCurrency, {
          alphabeticCode: row[target],
        });
        if (!rule) {
          return formatCurrency(value);
        }
        // 小数点以下は通貨の指定桁で切り捨て0埋め
        return formatCurrency(value, rule.symbol, rule.minorUnit);
      }
      if (column.type === 'Quantity') {
        const target = _.get(
          _.find(props.cols, { key: column.property }),
          'target',
        );
        return formatQuantity(value, row[target]);
      }

      return value;
    };

    const rowClassName = ({ row }) => {
      if (localEditMode.value) return undefined;

      if (row.detailViewableFlg === DETAIL_VIEWABLE_FLG.OFF) {
        return 'pointer-row disabled';
      }

      // if (!row.from?.sectionId || !row.to?.sectionId) {
      //   return 'pointer-row disabled';
      // }
      return 'pointer-row';
    };

    const handleSortChange = ({ column, prop, order }) => {
      activeSortState.value = order
        ? { prop, order }
        : { prop: null, order: null };
      emit(EMITS.SORT_CHANGE, { prop, order });
    };

    const handleColumnWidthChange = (newWidth, oldWidth, column, event) => {
      emit(EMITS.COLUMN_WIDTH_CHANGE, {
        newWidth,
        column,
      });
    };

    const getColumnWidths = () => {
      const tableEl = tableRef.value?.$el;
      if (!tableEl) return;
      const ths = tableEl.querySelectorAll('thead th');
      // const widths = Array.from(ths).map(th => th.offsetWidth);
    };

    const updateTableHeight = () => {
      const offset = offsetY.value; // headerやfooter、padding分の高さ
      tableHeight.value = window.innerHeight - offset;
    };

    const emitUpdate = (rowIndex, prop, value, row) => {
      const updated = [...tableData.value];
      updated[rowIndex] = { ...updated[rowIndex], [prop]: value };
      emit(EMITS.UPDATE_TABLE_DATA, updated);
      emit(EMITS.UPDATE_CELL, {
        rowIndex,
        prop,
        value,
        row,
      });
    };

    // 多言語対応したラベルを返却します
    const getLabel = label => {
      if (label === 'Trading Flow Status') return '';
      if (root.$te(`List.${label}`)) {
        return root.$t(`List.${label}`);
      }
      return label;
    };

    const getProgressApproval = processId => {
      // return 'approval';
      return (
        _.get(processNames[processId.replace(/\d/g, '')], 'approval') || false
      );
    };

    // プロセスの省略名を取得します
    const getProcessExShortName = processId => {
      return processId === 'TPARB'
        ? root.$t(`Process.TPATPRB`)
        : root.$t(`Process.${processId.replace(/\d/g, '')}`) +
            getProcessNumber(processId);
    };

    const handleClickRow = (row, column, event) => {
      emit(EMITS.CLICK_ROW, row);
    };

    const handleClickEditSelectCustomerInfo = (
      prop,
      data,
      index,
      isEditable,
    ) => {
      if (isEditable !== 1) return;
      emit(EMITS.CLICK_SELECT_CUSTOMER, { flowSide: prop, row: data, index });
    };

    const handleClickDeleteProcess = process => {
      emit(EMITS.CLICK_DELETE_PROCESS, { process });
    };

    const onRowContextmenu = (row, column, event) => {
      event.preventDefault();
      let target = event.target;
      if (target.tagName.toUpperCase() !== 'TD') {
        target = target.closest('td');
      }
      const text = target?.innerText;
      if (text) {
       root.$copyText(text).then(() => {
            root.$message({
              message: 'Copied!',
              type: 'success',
            });
       }).catch(() => {});
      }
    };

    const isFwd = computed(() => {
      return root.$store.getters.isFwd;
    });

    onBeforeMount(() => {
      if (!props.autoHeight)
        window.removeEventListener('resize', updateTableHeight);
    });

    onMounted(() => {
      nextTick(() => {
        if (!props.autoHeight) {
          updateTableHeight();
        } else {
          tableHeight.value = undefined;
        }
      });
      if (!props.autoHeight)
        window.addEventListener('resize', updateTableHeight);
    });

    return {
      dayjs,
      maskStr,
      localEditMode,
      localTableData: tableData,
      localCols: cols,
      localSize: size,
      localStripe: stripe,
      handleColumnWidthChange,
      handleSortChange,
      tableRef,
      tableHeight,
      getCategoryName,
      getUserIcon,
      getFlowLabel,
      getSortClass,
      getColumnWidths,
      canDeleteProcess,
      TwTableCell,
      formatter,
      getLabel,
      getProgressApproval,
      getProcessExShortName,
      isEventCancelProcess,
      isHazardous,
      emitUpdate,
      handleClickRow,
      handleClickEditSelectCustomerInfo,
      handleClickDeleteProcess,
      onRowContextmenu,
      rowClassName,
      visibleFlg,
      isFwd,
      isForcedClose,
    };
  },
});
</script>
<style>
.el-table--border th,
.el-table--border td {
  border-right: 1px solid #bfbfcd;
}
</style>
<style scoped>
.text-bold {
  font-weight: bold;
}
::v-deep .el-table__body-wrapper {
  background-color: #fafafa;
}

::v-deep .pointer-row {
  cursor: pointer;
}

::v-deep .pointer-row:hover > th {
  background-color: #aaa !important;
  transition: background-color 0.2s ease;
}

::v-deep .pointer-row:hover > td {
  background-color: #f5f7fa !important;
  transition: background-color 0.2s ease;
}

::v-deep .pointer-row > td:hover {
  background-color: #f5f7fa !important;
  transition: background-color 0.2s ease;
}
/* table-header style */
::v-deep .el-table__header th {
  background-color: #f1f1fb;
  color: #333333;
  font-weight: bold;
  font-size: 11px;
  padding: 0px;
}

::v-deep .el-table__header th:hover {
  background-color: #e3e3f7;
  transition: background-color 0.2s ease;
}

::v-deep .el-table--border {
  color: #999;
}

::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  width: 0;
  height: 0;
  background: transparent;
}
/* 常に表示される縦スクロールバー */
::v-deep .el-table__body-wrapper::-webkit-scrollbar:vertical {
  width: 8px;
}
/* hover 時のみ表示される横スクロールバー */
::v-deep .el-table__body-wrapper::-webkit-scrollbar:horizontal {
  height: 0;
}
::v-deep .el-table__body-wrapper:hover::-webkit-scrollbar:horizontal {
  height: 8px;
}
/* 共通のつまみスタイル */
::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.15);
  border-radius: 4px;
}

::v-deep .cell {
  line-height: 1.5;
}

::v-deep .tw_status_bar .top {
  font-size: 12px;
  margin-bottom: 4px;
}

::v-deep .tw_status_bar .top i {
  width: 14px;
  height: 14px;
}

::v-deep tr.disabled * {
  cursor: not-allowed;
}

::v-deep .el-table__header th .cell {
  display: flex;
  align-items: center;
  overflow: hidden;
}
::v-deep .el-table__header th .cell .th-text {
  min-width: 0;
  flex: 1 1 auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* ソートアイコン（caret）は固定幅で右側 */
::v-deep .el-table__header th .cell .caret-wrapper {
  flex: 0 0 auto;
  margin-left: 6px;
}

.no-margin {
  margin-bottom: 0 !important;
}

.editSelectCustomerInfo {
  background-color: #f9f9fd;
  border: 1px solid #ededf4;
  border-radius: 4px;
}
.editSelectCustomerInfo:hover {
  border: 1px solid #ccc;
}
.invalid {
  border-color: red;
}

.process-user-memo {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.5;
  white-space: pre-wrap;
  overflow-wrap: break-word;
}

.flow-m {
  background-color: #8ac7ff;
  color: #fff;
  width: 13px;
  height: 100%;
  text-align: center;
}

.flow-s {
  background-color: #dceeff;
  color: #70b7f8;
  width: 13px;
  height: 100%;
  text-align: center;
}
</style>
